<template>
  <bridged-a class="padlet-card inverse-scheme"
             bridge-target="padlet"
             :href="'/' + wall.address"
             target="_blank"
             :style="{ background: backgroundStyle }"
             data-app-target="blank">
    <div class="padlet-card-header">
      <div class="padlet-card-title">
        <h3>{{ title }}</h3>
        <div v-if="tagList" class="padlet-card-tags">{{ tagList }}</div>
      </div>
      <div v-if="actions" class="padlet-card-actions">
        <padlet-card-actions :wall="wall" />
      </div>
    </div>
    <div class="padlet-card-attribution">
      <avatar-image class="avatar"
                    :user="wall.builder"
                    width="24"
                    height="24" />
      <div class="padlet-card-attribution-text">
        <div class="padlet-card-builder">{{ wall.builder.display_name }}</div>
        <relative-time :datetime="wall.updated_at" dateformat="long" />
      </div>
    </div>
  </bridged-a>
</template>

<script>
import { processedUrl } from '@padlet/vivaldi-client'

import { __ } from 'bits/intl'
import BridgedA from './bridged_a'
import RelativeTime from './relative_time'
import AvatarImage from './avatar_image'
import PadletCardActions from './padlet_card_actions'

export default {
  components: { RelativeTime, AvatarImage, BridgedA, PadletCardActions },
  props: ['wall', 'actions'],
  computed: {
    title () {
      return this.wall.title || __('Untitled padlet')
    },
    tagList () {
      if (this.wall.public_tag_list) {
        return this.wall.public_tag_list.map((x) => { return '#' + x }).join('  ')
      }
      return ''
    },
    backgroundStyle () {
      var backgroundImage,
        backgroundUrl,
        backgrounds,
        bg,
        dominantColor,
        dominantColorAsRgb,
        lightest,
        linearGradient,
        overlayColor,
        ratio,
        ref,
        translucentBottomColor,
        translucentTopColor
      backgrounds = []
      bg = this.wall.background
      dominantColor = (ref = bg.dominant_color) != null ? ref : [0, 0, 0]
      lightest = Math.max.apply(null, dominantColor)
      ratio = 32.0 / lightest
      if (ratio < 1) {
        overlayColor = dominantColor.map((num) => {
          return parseInt(num * ratio, 10)
        })
      } else {
        overlayColor = dominantColor
      }
      dominantColorAsRgb = `rgb(${dominantColor.join(',')})`
      backgrounds.unshift(dominantColorAsRgb)
      if (bg.url) {
        backgroundUrl = processedUrl(bg.url, {
          crop: 'thumb',
          width: 232,
          height: 130,
        })
        backgroundImage = `url("${backgroundUrl}") center/cover`
        backgrounds.unshift(backgroundImage)
        translucentTopColor = `rgba(${overlayColor.join(',')},0.54)`
        translucentBottomColor = `rgba(${overlayColor.join(',')},0.54)`
        linearGradient = `linear-gradient(${translucentTopColor} 0%, ${translucentBottomColor} 100%)`
        backgrounds.unshift(linearGradient)
      }
      return backgrounds.join(',')
    },
  },
}
</script>

<style lang="scss">
@import "./../../assets/stylesheets/3/modules/all";

.padlet-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 232px;
  height: 130px;
  background-color: $superlight-grey;
  border-radius: 8px;
  font-size: 16px;
  line-height: 22px;
  padding: 8px 16px 16px;
  box-sizing: border-box;
  margin: 8px;
  background-size: cover;
  color: $inverse-text-color;

  &:visited {
    color: $inverse-text-color;
  }

  @include hover {
    color: white;
  }

  .padlet-card-header {
    display: flex;
    flex-direction: row;
  }

  .padlet-card-title {
    height: 66px;
    overflow: hidden;
    word-break: break-word;
  }

  .padlet-card-tags {
    font-size: 12px;
    color: $inverse-caption-text-color;
  }

  h3 {
    font-weight: 500;
  }
}

.padlet-card-attribution {
  display: flex;
  align-items: center;
  font-size: 11px;
  line-height: 14px;

  img {
    @include directional-margin($margin-top: 0, $margin-right: 8px, $margin-bottom: 0, $margin-left: 0);
  }
}

.padlet-card-attribution-text {
  // This is a hack to get ellipsify text working below.
  min-width: 0;
}

.padlet-card-builder {
  @include ellipsify-text;
}

.padlet-card-actions {
  /* adds space between itself and padlet-card-title */
  margin-left: auto;
  /* moves to the top-right corner of the padlet-card.
  works because padlet-card has a fixed width. */
  margin-right: -24px;
  margin-top: -8px;

  button {
    background-color: transparent;
    border: 0;
  }
}
</style>
